<template>
  <div class="rounded bg-grey_3 pa-3 mb-4 course_item bordered">
    <div class="text-h5 mb-4 font-weight-bold">
      {{ course.nom }} <v-chip color="primary-dark" variant="elevated" elevation="0" density="compact">{{ course.nb_inscrits }} inscrits</v-chip>
    </div>
    <div class="text-h6 mb-3">Informations</div>
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field v-model="course.nom" label="Nom de la course"></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-switch v-model="course.ouvert" hide-details true-value="1" false-value="0" :label="course.ouvert == '1' ? 'Inscriptions ouvertes pour la course' : ' Inscriptions fermées pour la course'" color="green" inset></v-switch>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field v-model="course.date_depart" type="date" label="Date de départ"></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field v-model="course.heure_depart" type="time" label="Heure de départ"></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6">
        <div class="text-dark-red text-subtitle-2"></div>
        <v-text-field v-model="course.max_inscrits" type="number" :disabled="is_disabled" label="Max inscrits (0 si pas de limite)"></v-text-field>
      </v-col>
      <v-col cols="12" md="6" v-if="is_disabled">
        <v-alert border="start" border-color="red" density="compact">La modification de ce champ à des répercussions sur d'autres paramètres du module d'inscription. Veuillez contacter yann@sportips.fr</v-alert>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <div class="text-h6 mb-3">Les tarifs</div>

    <div v-if="course.tarifs && course.tarifs.list">
      <TarifCourseItem v-for="tarif in course.tarifs.list" :item="tarif" :key="tarif.id"></TarifCourseItem>
    </div>
  </div>
</template>

<script>
import Course from "@/classes/Courses/Course.class";
import TarifCourseItem from "@/components/Administration/ConfigurationModule/Config_Courses/Tarif_Course_Item.vue";
export default {
  components: { TarifCourseItem },
  props: ["item"],
  data() {
    return {
      course: new Course(),
    };
  },
  computed: {
    is_disabled() {
      return !this.course.is_max_editable();
    },
  },

  mounted() {
    this.course = this.item;
  },
};
</script>

<style lang="scss" scoped>
</style>